import dynamic from 'next/dynamic'

export const DynamicConfirmAddressModal = dynamic(
  async () => (await import('.')).ConfirmAddressModal,
  { ssr: false },
)
